<template>
    <div id="reservation_list">


        <el-radio-group v-model="tabAction" style="margin-bottom: 15px;">
            <el-radio-button v-for="item in $const.TRAVELTRIPSTATUS" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
            <el-radio-button label="">全部</el-radio-button>
        </el-radio-group>

        <custom-table has-organization="true" ref="customTable" :customOptions="customOptions" :columns="columns" style="height: 95%;" :excel-type="btnPreFn('travel_order_driver_export', false) ? 'TravelOrderDriver' : ''">
            <template slot="table-operation">
                <el-table-column label="操作" width="120" fixed="right">
                    <div slot-scope="{ row }" class="custom-action">
                        <el-button type="text" @click="viewTrip(row)">详情</el-button>
                    </div>
                </el-table-column>
            </template>

            <template slot-scope="{ item, row }">
                <template v-if="['created', 'finishTime', 'orderTime'].includes(item.prop)">
                    {{ row[item.prop] | filterTime }}
                </template>
                <template  v-else-if="item.prop === 'orderDriverNo'">
                    <span class="link" @click="viewTrip(row)">{{row.orderDriverNo}}</span>
                    <el-tag class="ml-5" v-for="item in $const.TRAVELTRIPSTATUS.filter(item => item.value === row.status)" :key="item.value" :type="item.type">{{ item.label }}</el-tag>
                </template>
                <template v-else-if="item.prop === 'fee'">
                    <span class="util-money"> ￥{{ row.fee }} </span>
                </template>
                <template v-else-if="item.prop === 'passengerNum'">
                    <span> {{ row.passengerNum }}人 </span>
                </template>
                <template v-else-if="item.prop === 'licenseNo'">
                    <span 
                      v-if="row.licenseNo"
                      :style="getPlateStyle(row.licenseNo)"
                      @dblclick="$utils.dblclickCopy"
                    >{{ formatPlateNumber(row.licenseNo) }}</span>
                    <span v-else>-</span>
                    <span v-if="row.vehicleSeat" style="margin-left: 4px;">{{ row.vehicleSeat }}座</span>
                </template>

                <template v-else>
                    <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
                </template>
            </template>
        </custom-table>

        
    </div>
</template>

<script>

export default {
    name: "reservation_list",
    data() {
        return {
            tabAction: 10,
            // 配置项
            customOptions: {
                url: "/api/v1/manage/travelOrder/order/driver/list",
                params: {
                    page: 1, // 页数
                    size: 20, // 每页条数
                    status: 10
                },
                search: [
                    { type: "input", field: "orderDriverNo", name: "行程编号", value: "" },
                    { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
                    { type: "input", field: "driverName", name: "司机姓名", value: "" },
                    { type: "input", field: "driverPhone", name: "司机电话", value: "" },
                    { type: "datetime", disabledDate: false, field: "orderTime", name: "用车时间", dateProp: { start: "startOrderTime", end: "endOrderTime" }, value: []},
                    { type: "datetime", disabledDate: false, field: "created", dateProp: { start: "startTime", end: "endTime" }, name: "下单时间", value: [] },
                    { type: "datetime", disabledDate: false, field: "finishTime", dateProp: { start: "startFinishTime", end: "endFinishTime" }, name: "完成/取消时间", value: [] },
                ],
            },
            // 表头
            columns: [
                { prop: "orderDriverNo", label: "行程编号", width: 200 },
                { prop: "travelLineName", label: "线路名称", minWidth: 170 },
                { prop: "orderTime", label: "用车时间", minWidth: 120 },
                { prop: "passengerNum", label: "乘客数", minWidth: 80 },
                { prop: "licenseNo", label: "车辆号牌", minWidth: 120 },
                { prop: "driverName", label: "司机姓名", minWidth: 80 },
                { prop: "driverPhone", label: "司机电话", minWidth: 100 },
                { prop: "fee", label: "行程费用", minWidth: 100 },
                { prop: "created", label: "创建时间", minWidth: 120 },
                { prop: "finishTime", label: "完成/取消时间", minWidth: 120 },
            ],
            
        };
    },
    watch: {
        tabAction(val) {
            this.customOptions.params.page = 1;
            this.customOptions.params.status = val != "all" ? val : null;
            this.$refs.customTable.listFn();
        },
    },
    created() {
        
    },
    methods: {
        viewTrip(row) {
            this.$router.push({
                path: '/travelSchedulingDetail',
                query: {
                    id: row.id
                }
            })
        },
        
    },
};
</script>

<style lang="less" scoped>
#reservation_list {
    // 状态筛选
    .el-radio-group {
        background: #f5f7fa;
        border-radius: 8px;
        padding: 4px;
        display: inline-flex;
        
        .el-radio-button {
            margin: 0 2px;
            
            /deep/ .el-radio-button__inner {
                background: transparent;
                border: none;
                border-radius: 6px;
                padding: 8px 16px;
                font-size: 13px;
            }
            
            &.is-active /deep/ .el-radio-button__inner {
                background: #2B77FF;
                color: #fff;
                box-shadow: none;
            }
        }
    }

    // 操作按钮
    .custom-action {
        display: flex;
        align-items: center;
        gap: 8px;
        
        .el-button--text {
            padding: 0;
            color: #2B77FF;
            
            &:hover {
                color: #1a5fd9;
            }
        }
    }

    // 链接样式
    .link {
        color: #2B77FF;
        cursor: pointer;
        
        &:hover {
            text-decoration: underline;
        }
    }

    // 价格样式
    .util-money {
        font-weight: 600;
        color: #F56C6C;
    }

    // 标签间距
    .ml-5 {
        margin-left: 5px;
    }
}
</style>
